var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TreeSelect',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"data":_vm.data,"append-to-body":_vm.appendToBody,"clearable":_vm.clearable,"inline":_vm.inline},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }